import React from 'react'
import { Link } from 'react-router-dom'
import AccountPropertyListSF from '../account/util/AccountPropertyListSF'

const MCABalanceSheetChargesUI = ({context, account, bsList}) =>
  <div id='mcaSubCharges' className='g_m_top_200'>
    <b className='g_large'>Subservient Charges</b>
    <table className='g_table'>
      <thead className='g_sticky'><tr>
        <td className='g_text_center'><b>Particulars</b></td>
        <td className='g_text_center'><b>From last<br/>audited year<br/>(A)</b></td>
        <td className='g_text_center'><b>RV %<br/>(B)</b></td>
        <td className='g_text_center'><b>RV Amount<br/>(A*B)</b></td>
      </tr></thead>
      <tbody>
      <tr><td colSpan='8'><b className='g_m_top_200'>Non-current Assets</b></td></tr>
      <RowUI bsList={bsList} rv='50' name='tangibleAssets' />
      <RowUI bsList={bsList} rv='50' name='otherTangibleAssets' />
      <RowUI bsList={bsList} rv='0' name='intangibleAssets' />
      <RowUI bsList={bsList} rv='50' name='capitalWorkInProgress' />
      <RowUI bsList={bsList} rv='0' name='intangibleAssetsUnderDevelopment' />
      <RowUI bsList={bsList} rv='75' name='nonCurrentInvestments' />
      <RowUI bsList={bsList} rv='50' name='longTermLoansAndAdvances' />
      <RowUI bsList={bsList} rv='0' name='deferredTaxAssets' />
      <RowUI bsList={bsList} rv='50' name='otherNonCurrentAssets' />
      <RowUI bsList={bsList} total={true} name='totalNonCurrentAssets' />
      <tr><td colSpan='8'><b className='g_m_top_200'>Current Assets</b></td></tr>
      <RowUI bsList={bsList} rv='75' name='currentInvestments' />
      <RowUI bsList={bsList} rv='50' name='inventories' />
      <RowUI bsList={bsList} rv='20' name='shortTermLoansAndAdvances' />
      <RowUI bsList={bsList} rv='80' name='tradeReceivables' />
      <RowUI bsList={bsList} rv='100' name='cashAndBankBalances' />
      <RowUI bsList={bsList} rv='0' name='otherCurrentAssets' />
      <RowUI bsList={bsList} total={true} name='totalCurrentAssets' />
      <RowUI bsList={bsList} total={true} name='totalAssets' />
      <tr><td colSpan='8'><b>Non-current Liabilities</b></td></tr>
      <RowUI bsList={bsList} rv='100' name='securedLongTermBorrowings' />
      <RowUI bsList={bsList} rv='100' name='unsecuredLongTermBorrowings' />
      <RowUI bsList={bsList} rv='0' name='longTermProvisions' />
      <RowUI bsList={bsList} rv='0' name='deferredTaxLiabilities' />
      <RowUI bsList={bsList} rv='100' name='otherNonCurrentLiabilities' />
      <RowUI bsList={bsList} total={true} name='totalNonCurrentLiabilities' />
      <tr><td colSpan='8'><b>Current Liabilities</b></td></tr>
      <RowUI bsList={bsList} rv='100' name='securedShortTermBorrowings' />
      <RowUI bsList={bsList} rv='100' name='tradePayables' />
      <RowUI bsList={bsList} rv='0' name='shortTermProvisions' />
      <RowUI bsList={bsList} rv='0' name='currentDeferredTaxLiabilities' />
      <RowUI bsList={bsList} rv='100' name='otherCurrentLiabilities' />
      <RowUI bsList={bsList} total={true} name='totalCurrentLiabilities' />
      <RowUI bsList={bsList} total={true} name='totalLiabilities' />
      <TotalUI bsList={bsList} total={true} name='totalChargeValue' />

      {/*
      <tr><td colSpan='8'><b>Equity & Liabilities</b></td></tr>
      <RowUI bsList={bsList} name='equityShareCapital' />
      <RowUI bsList={bsList} name='otherEquity' />
      <RowUI bsList={bsList} name='reserveSurplus' />
      <RowUI bsList={bsList} name='others' />
      <RowUI bsList={bsList} total={true} name='totalEquity' />
      <RowUI bsList={bsList} total={true} name='totalEquityAndLiabilities' />
      */}
      {/*

      */}
      </tbody>
    </table>

    <AccountPropertyListSF context={context} account={account}
      category='subservient' categoryLabel='Subservient charge RV%' />

  </div>

const RowUI = ({bsList, rv, total, name}) =>
  <tr className={total && 'g_table_total'}>
    <td><Desc name={name} /></td>
    <td className='g_text_right g_m_left_100'>
      {bsList.length > 0 && bsList[bsList.length - 1][name]}
    </td>
    <td className='g_text_right g_m_left_100'>
      {bsList.length > 0 && bsList[bsList.length - 1][name + 'RV']}
    </td>
    <td className='g_text_right g_m_left_100'>
      {bsList.length > 0 && bsList[bsList.length - 1][name + 'Charge']}
    </td>
  </tr>

  const TotalUI = ({bsList, rv, total, name}) =>
    <tr className={total && 'g_table_total'}>
      <td colSpan='3'><Desc name={name} /></td>
      <td className='g_text_right g_m_left_100'>
        {bsList.length > 0 && bsList[bsList.length - 1][name]}
      </td>
    </tr>

  const Desc = ({name}) =>
    <span>
      {(() => {
        switch (name) {
          case 'equityShareCapital':
          return 'Equity Share Capital'
          case 'otherEquity':
          return 'Other Equity'
          case 'reserveSurplus':
          return 'Reserve & Surplus'
          case 'others':
          return 'Others'
          case 'totalEquity':
          return 'Total Equity'
          case 'securedLongTermBorrowings':
          return 'Secured Long-term Borrowings'
          case 'unsecuredLongTermBorrowings':
          return 'Unsecured Long-term Borrowings'
          case 'longTermProvisions':
          return 'Long Term Provisions'
          case 'deferredTaxLiabilities':
          return 'Deferred Tax Liabilities'
          case 'otherNonCurrentLiabilities':
          return 'Other Non-Current Liabilities'
          case 'totalNonCurrentLiabilities':
          return 'Total Non-Current Liabilities'
          case 'securedShortTermBorrowings':
          return 'Secured Short-term Borrowings'
          case 'tradePayables':
          return 'Trade Payables'
          case 'shortTermProvisions':
          return 'Short Term Provisions'
          case 'currentDeferredTaxLiabilities':
          return 'Current Deferred Tax Liabilities'
          case 'otherCurrentLiabilities':
          return 'Other Current Liabilities'
          case 'totalCurrentLiabilities':
          return 'Total Current Liabilities'
          case 'totalLiabilities':
          return 'Total Liabilities'
          case 'totalEquityAndLiabilities':
          return 'Total Equity and Liabilities'

          case 'tangibleAssets':
          return 'Tangible Assets'
          case 'otherTangibleAssets':
          return 'Other Tangible Assets'
          case 'intangibleAssets':
          return 'Intangible Assets'
          case 'capitalWorkInProgress':
          return 'Capital Work in Progress'
          case 'intangibleAssetsUnderDevelopment':
          return 'Intangible Assets under Development'
          case 'netFixedAssets':
          return 'Net Fixed Assets'
          case 'nonCurrentInvestments':
          return 'Non-current Investments'
          case 'longTermLoansAndAdvances':
          return 'Long Term Loans & Advances'
          case 'deferredTaxAssets':
          return 'Deferred Tax Assets'
          case 'otherNonCurrentAssets':
          return 'Other Non-Current Assets'
          case 'totalNonCurrentAssets':
          return 'Total Non-current Assets'
          case 'currentInvestments':
          return 'Current Investments'
          case 'inventories':
          return 'Inventories'
          case 'shortTermLoansAndAdvances':
          return 'Short Term Loans & Advances'
          case 'tradeReceivables':
          return 'Trade Receivables'
          case 'cashAndBankBalances':
          return 'Cash and Bank Balances'
          case 'otherCurrentAssets':
          return 'Other Current Assets'
          case 'totalCurrentAssets':
          return 'Total Current Assets'
          case 'totalAssets':
          return 'Total Assets'
          case 'totalChargeValue':
          return 'Total Charge Value'
          default:
            return name
        }
      })()}
    </span>

export default MCABalanceSheetChargesUI
